<template>
  <div></div>
</template>
<script>
const isMobile = {
  Android: function() {
    return navigator.userAgent.match(/Android/i) ? !0 : !1;
  },
  iOS: function() {
    return navigator.userAgent.match(/iPhone|ipad|iPod/i) ? !0 : !1;
  },
  BlackBerry: function() {
    return navigator.userAgent.match(/BlackBerry/i) ? !0 : !1;
  },
  Windows: function() {
    return navigator.userAgent.match(/IEMobile/i) ? !0 : !1;
  },
  any: function() {
    return this.Android() || this.BlackBerry() || this.iOS() || this.Windows();
  }
};

export default {
  mounted() {
    this.closeWindow();
  },
  methods: {
    // 调用APP关闭方法
    closeWindow() {
      let { OPay = {}, webkit = {} } = window;

      if (isMobile.Android()) {
        // android关闭调用的方法是OPay.closeWebView()
        return typeof OPay.closeWebView === "function"
          ? OPay.closeWebView()
          : "";
      } else if (isMobile.iOS()) {
        // @许鑫  按照这种 window.webkit.messageHandlers.<name>.postMessage(<messageBody>) 格式调用。 具体内容h5那边定义好后告诉我们进行联调就可以了。 比如：
        // 不带参数：
        // window.webkit.messageHandlers.closeWindow.postMessage(null)
        // 带参数：
        // window.webkit.messageHandlers.closeWindow.postMessage({ test: test})
        return webkit.messageHandlers
          ? webkit.messageHandlers.closeWindow.postMessage(null)
          : "";
      } else {
        // let data = localStorage.getItem("opay-params");
        // localStorage.removeItem("opay-params");
        // // 跳回收银台首页
        // this.$router.push({
        //   path: "/home",
        //   query: {
        //     data
        //   }
        // });
        let url = localStorage.getItem("opay-cashier-url");
        localStorage.removeItem("opay-cashier-url");

        if (url) {
          location.href = url;
        }  
      }
    }
  }
};
</script>
